module.exports = __webpack_public_path__ + "img/what_we_do.40c5612e.svg";